import React from "react";
import { BrowserRouter, Switch, Route as PublicRoute } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Kanban from "../pages/Kanban/";
import Statistics from "../pages/Statistics/";
import Bot from "../pages/Bot/";
import Roles from "../pages/Roles/";
import AuditLogs from "../pages/AuditLogs/";
import DataCleanManager from "../pages/DataCleanManager/";
import Appointments from "../pages/Appointments/";
import AppointmentConfirm from "../pages/AppointmentConfirm/";
import PublicBooking from "../pages/PublicBooking/";
import Billing from "../pages/Billing/";
import BillingSettings from "../pages/BillingSettings/";
import Costs from "../pages/Costs/";
import InvoiceReceipt from "../pages/InvoiceReceipt/";
import EmailMarketing from "../pages/EmailMarketing/";
import EmailUnsubscribe from "../pages/EmailUnsubscribe/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            {/* Public appointment confirmation. Deliberately uses the raw
                react-router Route: the local wrapper bounces logged-in users
                away from non-private routes, which would kick an agent out
                of the very link they are trying to check. */}
            <PublicRoute exact path="/cita/:token" component={AppointmentConfirm} />
            {/* Auto-reserva: cualquier visitante puede agendar una cita nueva
                sin sesión, sin token (todavía no existe la cita). */}
            <PublicRoute exact path="/agendar" component={PublicBooking} />
            {/* Payment return page: same reasoning as /cita — the customer may
                well be logged in, and the local wrapper would bounce them. */}
            <PublicRoute exact path="/factura/:publicToken" component={InvoiceReceipt} />
            {/* Link de baja en el correo — mismo motivo que /cita y /factura:
                el destinatario puede estar logueado como agente y no debe
                rebotarlo. */}
            <PublicRoute exact path="/email/unsubscribe/:token" component={EmailUnsubscribe} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/appointments" component={Appointments} isPrivate />
                <Route exact path="/billing" component={Billing} isPrivate />
                <Route exact path="/billing-settings" component={BillingSettings} isPrivate />
                <Route exact path="/costs" component={Costs} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
                <Route exact path="/kanban" component={Kanban} isPrivate />
                <Route exact path="/statistics" component={Statistics} isPrivate />
                <Route exact path="/bot" component={Bot} isPrivate />
                <Route exact path="/email-marketing" component={EmailMarketing} isPrivate />
                <Route exact path="/roles" component={Roles} isPrivate />
                <Route exact path="/audit-logs" component={AuditLogs} isPrivate />
                <Route exact path="/data-clean-manager" component={DataCleanManager} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
